<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>生产管理</el-breadcrumb-item>
      <el-breadcrumb-item>订单管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <RsljigouInternal :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigouInternal"></RsljigouInternal>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.orderid" @keyup.enter.native="clicksearch" placeholder="请输入订单号"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.orderstatus" placeholder="请选择" class="select">
              <el-option label="请选择订单状态" value="-1"></el-option>
              <el-option label="已创建" value="0"></el-option>
              <el-option label="已审核" value="1"></el-option>
              <el-option label="已部分完成" value="2"></el-option>
              <el-option label="已全部完成" value="3"></el-option>
              <el-option label="已取消" value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.bomsn" @keyup.enter.native="clicksearch" placeholder="请输入材料编号"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->
        <!-- 数据列表 start -->
        <el-table :data="dataList" height="500" border stripe>
          <el-table-column prop="JigouName" label="所属公司名称"></el-table-column>
          <el-table-column prop="Orderid" label="订单号"></el-table-column>
          <el-table-column prop="Ordertypes" label="订单属性"></el-table-column>
          <el-table-column prop="Orderstatuss" label="订单状态"></el-table-column>
          <el-table-column prop="Bomsn" label="材料编号"></el-table-column>
          <el-table-column prop="Productname" label="材料名称"></el-table-column>
          <el-table-column prop="Manufacturer" label="生产厂家"></el-table-column>
          <el-table-column prop="Endtime" label="交货日期"></el-table-column>
          <el-table-column prop="Amount" label="订单金额"></el-table-column>
          <el-table-column prop="Targetnum" label="订单数量"></el-table-column>
          <el-table-column prop="Receivenum" label="已交付数量"></el-table-column>
          <el-table-column prop="Beizhu" label="备注"></el-table-column>
          <el-table-column label="附件">
            <template v-slot="scope">
              <el-button v-for="Attachment in scope.row.Attachments" type="text" @click="clickfile(Attachment)">附件</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="Createtime" label="创建时间"></el-table-column>
          <el-table-column prop="Operation" label="操作" width="200px">
            <template v-slot="scope">
              <el-button v-if="scope.row.Orderstatus == 0 && SubRule_MadeManagement_MadeOrderShenHe" type="text" @click="clickshenhe(scope.row)">总经理审核</el-button>
              <el-button v-if="scope.row.Orderstatus == 0" type="text" @click="clickcancel(scope.row)">取消订单</el-button>
              <el-button v-if="scope.row.Orderstatus <= 2" type="text" @click="clickdelay(scope.row)">延期订单</el-button>
              <el-button v-if="scope.row.Orderstatus <= 2" type="text" @click="clicktargetnum(scope.row)">修改订单数量</el-button>
              <el-button v-if="scope.row.Orderstatus == 1 || scope.row.Orderstatus == 2" type="text" @click="clicksubmitnum(scope.row)">录入交付数量</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->
        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 延期订单弹出框 -->
    <el-dialog title="延期订单" :visible.sync="delaydialog" width="30%" :close-on-click-modal="false">
      <el-form :model="delayForm" ref="delayFormRef" label-width="70px">
        <el-form-item label="交货日期" class="addAdminForm">
          <el-date-picker v-model="delayForm.endtime" type="date" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clicksavedelay">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 延期订单弹出框 end -->

    <!-- 订单数量弹出框 -->
    <el-dialog title="订单数量" :visible.sync="targetnumdialog" width="30%" :close-on-click-modal="false">
      <el-form :model="targetnumForm" ref="targetnumFormRef" label-width="70px">
        <el-form-item label="订单数量" class="addAdminForm">
          <el-input v-model="targetnumForm.targetnum" placeholder="请输入订单数量"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clicksavetargetnum">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 订单数量弹出框 end -->

    <!-- 录入交付数量弹出框 -->
    <el-dialog title="录入交付数量" :visible.sync="submitnumdialog" width="30%" :close-on-click-modal="false">
      <el-form :model="submitnumForm" ref="submitnumFormRef" label-width="70px">
        <el-form-item label="交付数量" class="addAdminForm">
          <el-input v-model="submitnumForm.num" placeholder="请输入交付数量"></el-input>
          只需要输入本次实际收到的产品的数量
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clicksavesubmitnum">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 录入交付数量弹出框 end -->

    <!-- 添加订单 start -->
    <el-tab-pane label="添加订单" name="second">
      <div class="title">自产不需要供应商</div>
      <el-form :model="addForm" ref="addFormRef" label-width="100px">
        <el-form-item label="订单属性" class="addAdminForm">
          <el-select v-model="addForm.ordertype" placeholder="请选择" class="select2">
            <el-option label="采购" value="1"></el-option>
            <el-option label="自产" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="材料编号" class="addAdminForm">
          <el-input v-model="addForm.bomsn" placeholder="请输入材料编号"></el-input>
          <el-button type="success" plain @click="apiCheckProjectbom">校验</el-button>
          <li>项目名称：{{addForm.parentname}}</li>
          <li>材料名称：{{addForm.name}}</li>
        </el-form-item>
        <el-form-item label="供应商" class="addAdminForm" v-if="addForm.ordertype == 1">
          <el-select v-model="addForm.suppliernameid" @change="changeoptionssuppliername" placeholder="请选择供应商" class="select2">
            <el-option
              v-for="item in optionssuppliername" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <li>含税价：{{addForm.pricetax}}</li>
          <li>未税价：{{addForm.pricenotax}}</li>
          <li>税率：{{addForm.rate}}</li>
        </el-form-item>
        <el-form-item label="订单数量" class="addAdminForm">
          <el-input v-model="addForm.targetnum" placeholder="请输入订单数量"></el-input>
        </el-form-item>
        <el-form-item label="交货日期" class="addAdminForm">
          <el-date-picker v-model="addForm.endtime" type="date" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="备注(可选)" class="addAdminForm">
          <el-input v-model="addForm.beizhu"></el-input>
        </el-form-item>
        <el-form-item label="附件(可选)" class="addAdminForm">
          <TencentyunCosUploadMultiImgOrPdf ref="MultiImgOrPdf" @change="addTencentyunCosUploadMultiImgOrPdf"></TencentyunCosUploadMultiImgOrPdf>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickadd">添加</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 添加订单 end -->
  </el-tabs>
  </div>
</template>

<script>
import RsljigouInternal from '@/components/RsljigouInternal.vue'
import TencentyunCosUploadMultiImgOrPdf from '@/components/TencentyunCosUploadMultiImgOrPdf.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    RsljigouInternal,
    TencentyunCosUploadMultiImgOrPdf
  },
  name: 'MyMadeOrder',
  data () {
    return {
      activeName: 'first',
      optionssuppliername: [],
      addForm: {
        bomsn: '',
        parentname: '',
        name: '',
        suppliernameid: '',
        suppliername: '',
        pricetax: '',
        pricenotax: '',
        rate: '',
        ordertype: '1',
        targetnum: '',
        endtime: '',
        beizhu: '',
        attachment: ''
      },
      keywords: {
        jigouid: '-1',
        jigouname: '',
        orderid: '',
        orderstatus: '-1',
        bomsn: ''
      },
      dataList: [],
      dataListnum: 0,
      delaydialog: false,
      delayForm: {
        id: '',
        endtime: ''
      },
      targetnumdialog: false,
      targetnumForm: {
        id: '',
        targetnum: ''
      },
      submitnumdialog: false,
      submitnumForm: {
        id: '',
        num: ''
      },
      selectedPageNo: 1,
      SubRule_MadeManagement_MadeOrderShenHe: false
    }
  },
  mounted () {
    this.apigetmadeordernum()
    this.apigetmadeorderlist()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_MadeManagement_MadeOrderShenHe', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_MadeManagement_MadeOrderShenHe = true
      }
    })
  },
  methods: {
    addTencentyunCosUploadMultiImgOrPdf (url) {
      this.addForm.attachment = url
    },
    changeRsljigouInternal (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    clickfile (url) {
      Vue.prototype.FunReviewFileurl(url, this.$router)
    },
    clickshenhe (row) {
      this.$confirm('是否通过此采购订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apieditmadeordershenhe(row.Id)
      })
    },
    clickcancel (row) {
      this.$confirm('是否取消此采购订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apieditmadeordercancel(row.Id)
      })
    },
    clickdelay (row) {
      this.delaydialog = true
      this.delayForm.id = row.Id
      this.delayForm.endtime = row.Endtime
    },
    clicktargetnum (row) {
      this.targetnumdialog = true
      this.targetnumForm.id = row.Id
      this.targetnumForm.targetnum = row.Targetnum
    },
    clicksubmitnum (row) {
      this.submitnumdialog = true
      this.submitnumForm.id = row.Id
      this.submitnumForm.num = '0'
    },
    clickadd () {
      if (this.addForm.ordertype == 2) {
        this.addForm.suppliernameid = '0'
        this.addForm.suppliername = '自产'
        this.addForm.pricetax = '0'
        this.addForm.pricenotax = '0'
        this.addForm.rate = '0'
      }
      if (!this.addForm.suppliername) {
        this.$alert('请选择供应商', '提示')
        return
      }
      if (!this.addForm.targetnum) {
        this.$alert('请输入订单数量', '提示')
        return
      }
      if (!this.addForm.endtime) {
        this.$alert('请选择交货日期', '提示')
        return
      }
      this.apiaddmadeorder()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clicksavedelay () {
      if (!this.delayForm.endtime) {
        this.$alert('请选择交货日期', '提示')
        return
      }
      this.apieditmadeorderdelay()
    },
    clicksavetargetnum () {
      if (!this.targetnumForm.targetnum) {
        this.$alert('请输入订单数量', '提示')
        return
      }
      this.apieditmadeordertargetnum()
    },
    clicksavesubmitnum () {
      if (!this.submitnumForm.num) {
        this.$alert('请输入本次交付数量', '提示')
        return
      }
      this.apieditmadeordersubmitnum()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apigetmadeordernum()
      this.apigetmadeorderlist()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apigetmadeorderlist()
    },
    changeoptionssuppliername (e) {
      var that = this
      that.optionssuppliername.filter((item1, i1) => {
        if (e === item1.value) {
          that.addForm.suppliernameid = item1.value
          that.addForm.suppliername = item1.label
          that.addForm.pricetax = item1.pricetax
          that.addForm.pricenotax = item1.pricenotax
          that.addForm.rate = item1.rate
        }
      })
    },
    apigetmadeordernum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: that.keywords.orderid,
        orderstatus: that.keywords.orderstatus,
        bomsn: that.keywords.bomsn,
        jigouid: that.keywords.jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getmadeordernum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apigetmadeorderlist: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        orderid: that.keywords.orderid,
        orderstatus: that.keywords.orderstatus,
        bomsn: that.keywords.bomsn,
        jigouid: that.keywords.jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getmadeorderlist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataList = response.data.List
            for (var i = 0; i < that.dataList.length; i++) {
              that.dataList[i].Attachments = []
              if (that.dataList[i].Attachment.length > 1) {
                that.dataList[i].Attachments = that.dataList[i].Attachment.split('@@@')
              }
            }
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiaddmadeorder: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        bomsn: this.addForm.bomsn,
        suppliername: this.addForm.suppliername,
        suppliernameid: this.addForm.suppliernameid,
        pricetax: this.addForm.pricetax,
        pricenotax: this.addForm.pricenotax,
        rate: this.addForm.rate,
        ordertype: this.addForm.ordertype,
        targetnum: this.addForm.targetnum,
        endtime: this.addForm.endtime,
        beizhu: this.addForm.beizhu,
        attachment: this.addForm.attachment
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Addmadeorder, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.addForm.suppliernameid = ''
            that.addForm.suppliername = ''
            that.addForm.pricetax = ''
            that.addForm.pricenotax = ''
            that.addForm.rate = ''
            that.addForm.beizhu = ''
            that.addForm.attachment = ''
            that.apigetmadeordernum()
            that.apigetmadeorderlist()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apieditmadeorderdelay: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: this.delayForm.id,
        endtime: this.delayForm.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editmadeorderdelay, Qs.stringify(data))
        .then(function (response) {
          that.apigetmadeorderlist()
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.delaydialog = false
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apieditmadeordershenhe: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editmadeordershenhe, Qs.stringify(data))
        .then(function (response) {
          that.apigetmadeorderlist()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apieditmadeordercancel: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editmadeordercancel, Qs.stringify(data))
        .then(function (response) {
          that.apigetmadeorderlist()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apieditmadeordertargetnum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: this.targetnumForm.id,
        targetnum: this.targetnumForm.targetnum
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editmadeordertargetnum, Qs.stringify(data))
        .then(function (response) {
          that.apigetmadeorderlist()
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.targetnumdialog = false
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apieditmadeordersubmitnum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: this.submitnumForm.id,
        num: this.submitnumForm.num
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editmadeordersubmitnum, Qs.stringify(data))
        .then(function (response) {
          that.apigetmadeorderlist()
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.submitnumdialog = false
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiCheckProjectbom: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        bomsn: that.addForm.bomsn
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_CheckProjectbom, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.addForm.bomsn = response.data.Bomsn
            that.addForm.parentname = response.data.Parentname
            that.addForm.name = response.data.Name

            that.optionssuppliername = []
            response.data.List.filter((item1, i1) => {
              that.optionssuppliername.push({ value: item1.Id, label: item1.Suppliername, pricetax: item1.Pricetax, pricenotax: item1.Pricenotax, rate: item1.Rate })
            })
            if (that.optionssuppliername.length > 0) {
              that.addForm.suppliernameid = that.optionssuppliername[0].value
              that.addForm.suppliername = that.optionssuppliername[0].label
              that.addForm.pricetax = that.optionssuppliername[0].pricetax
              that.addForm.pricenotax = that.optionssuppliername[0].pricenotax
              that.addForm.rate = that.optionssuppliername[0].rate
            } else {
              that.addForm.suppliernameid = ''
              that.addForm.suppliername = ''
              that.addForm.pricetax = ''
              that.addForm.pricenotax = ''
              that.addForm.rate = ''
            }
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
